<template>
    <div class="infoBox_ynjc">
        <div class="news_title_ynjc"  v-show="consultName!='下载专区'">
            <span class="news_title_ico_ynjc notices_title_ico"></span>
            <span class="news_title_text_ynjc">{{consultName}}</span>
            <router-link class="gd_news_box_title_more" :to="{ path: moreUrl}" target="_blank">更多&gt;&gt;</router-link>
        </div>
        <div class="notices_main_ynjc" v-show="consultName!='下载专区'">
            <ul>
                <li v-for="(item,index) in newsList" :key="item.id"  v-if="(settings.isSubject  && index>0 ) || !settings.isSubject">
                    <span class="notices_main_li_ico2_ynjc"></span>
                    <router-link class="gd_news_box_main_liIco" :to="{ path: '/newsInfo', query: { id: item.id }}" target="_blank" :title="item.newsTitle">{{item.newsTitle}}</router-link>
                    <span class="notices_main_li_time_ynjc" v-show="item.publishTime!=null && showPublishTime==true">{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                </li>
            </ul>
        </div>


        <!--下载专区-->
        <div class="news_title_ynjc" v-show="consultName=='下载专区'">
            <span class="news_title_ico_ynjc download_title_ico"></span>
            <span class="news_title_text_ynjc">{{consultName}}</span>
            <router-link class="gd_news_box_title_more" :to="{ path: moreUrl}" target="_blank">更多&gt;&gt;</router-link>
        </div>
        <div class="notices_main_ynjc"  v-show="consultName=='下载专区'">
            <ul class="download_main_ynjc">
                <li v-for="(item,index) in newsList" :key="item.id"  v-if="(settings.isSubject  && index>0 ) || !settings.isSubject">
                    <span class="notices_main_li_ico2_ynjc"></span>
                    <router-link  :to="{ path: '/newsInfo', query: { id: item.id }}" target="_blank" :title="item.newsTitle">{{item.newsTitle}}</router-link>
                    <!--<span class="notices_main_li_time_ynjc" v-show="item.publishTime!=null && showPublishTime==true">{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>-->
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
    import {listNews} from '../api/api';
    export default {
        props: {
            settings: {
                type: Object,
                default: function () {
                    return {
                        consultId: 28,
                        publishState: 0,
                        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                        'displayPositionIds': [1, 3],
                        'notProjectIds': [8, 9],
                        'orderWeight': true,
                        orderPublishTime: true,
                        pageNum: 1,
                        pageSize: 10,
                        showPublishTime:true
                    }
                },
                validator: function () {
                    let isValidator = true;
                    return isValidator
                }
            }
        },
        components: {},
        data () {
            return {
                newsList: [],
                consultName: this.settings.consultName,
                showPublishTime:this.settings.showPublishTime,
                moreUrl:this.settings.moreUrl
            }
        },
        mounted () {
            listNews(this.settings).then((response) => {
                this.newsList = response.data.data.list;
            })
        },
        computed: {},
        methods: {}
    }
</script>